import { useLocation } from 'react-router'
import { isIOS, isMobile } from 'react-device-detect'
import paths from 'config/paths'
import { config } from 'config'

export const useRedirectToShop = () => {
  const { pathname } = useLocation()

  const appleStorePath = config.APPLE_STORE_PATH

  const shouldRedirect =
    pathname !== paths.resetPassword && isMobile && pathname !== paths.confirm

  if (isIOS && shouldRedirect) window.location.href = appleStorePath

  return shouldRedirect
}
